import React from 'react';
import { Flex, Space, Divider, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { I18n } from 'react-redux-i18n';

interface ModelFileProps {
  label: string;
  fileName: string;
  filePath: string;
}

const ModelFile = (props: ModelFileProps) => {
  return (
    <Flex>
      <Space direction="vertical" className="width100">
        <p className="fileLabel">{props.label}</p>
        <p className="fileName">{props.fileName}</p>
        <Divider className="m-0" />
      </Space>
      <Flex align="center" className="ml-1">
        <Button
          type="primary"
          shape="round"
          className="export-button"
          icon={<DownloadOutlined className="download" />}
          href={props.filePath}
        >
          {I18n.t('negoce.submissions.modelFiles.buttonText')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ModelFile;
